<template>
  <div style="margin-top:30px">
    <el-form
      ref="form"
      :rules="rules"
      :model="form"
      label-width="100px"
    >
      <el-form-item
        label="管理员账号"
        prop="phone"
        style="margin-right:15px"
      >
        <el-input
          v-model="form.phone"
          placeholder="管理员账号"
          maxlength="32"
          @change="value=>form.phone = value.replace(/\s/g,'')"
        />
      </el-form-item>
      <el-form-item
        label="管理员名称"
        prop="name"
        style="margin-right:15px"
      >
        <el-input
          v-model="form.name"
          placeholder="管理员名称"
          maxlength="64"
          @change="value=>form.name = value.replace(/\s/g,'')"
        />
      </el-form-item>
      <el-form-item
        label="管理员密码"
        prop="currentPassword"
        style="margin-right:15px"
      >
        <el-input
          v-model="form.currentPassword"
          placeholder="登陆密码,默认为abcd1234"
          @change="value=>form.currentPassword = value.replace(/\s/g,'')"
        />
      </el-form-item>
      <el-form-item
        label="机构名称"
        prop="groupName"
        style="margin-right:15px"
      >
        <el-input
          v-model="form.groupName"
          placeholder="机构名称"
          maxlength="256"
          @change="value=>form.groupName = value.replace(/\s/g,'')"
        />
      </el-form-item>
      <el-form-item
        label="机构地址"
        prop="address"
        style="margin-right:15px"
      >
        <el-input
          v-model="form.address"
          placeholder="请输入地址"
          maxlength="500"
          @change="value=>form.address = value.replace(/\s/g,'')"
        />
      </el-form-item>
      <el-form-item
        label="400客服"
        prop="telephone"
        style="margin-right:15px"
      >
        <el-input
          v-model="form.telephone"
          placeholder="400-"
          maxlength="16"
          @change="value=>form.telephone = /^[-\d]+$/.test(value)?value:''"
        />
      </el-form-item>
      <el-form-item
        label="版本"
        prop="belong"
        style="margin-right:15px"
      >
        <el-radio-group v-model="form.belong">
          <el-radio
            v-for="item in belongList"
            :key="item.code"
            :label="item.code"
          >
            {{ item.name }}
          </el-radio>
        </el-radio-group>
      </el-form-item>
    </el-form>
    <div
      slot="footer"
      class="dialog-footer"
    >
      <el-button @click="funcCancel">
        取 消
      </el-button>
      <el-button
        type="primary"
        @click="funcSubmit"
      >
        确 定
      </el-button>
    </div>
  </div>
</template>
<script>
import request from '@/utils/request'
export default {
  name: 'PartnerShipsAdd',
  data() {
    return {
      form: {
        phone: '',
        currentPassword:'',
        name: '',
        groupName:'',
        address: '',
        amapType: '',
        branchPhone: '',
        pushModel: '',
        belong: [],
        softVersion: ''
      },
      // 用户类型（角色）
      partyTypeOptions: [],
      rules: {
        phone: [
          { required: true, message: '请输入管理员账号', trigger: 'blur' },
          { max:32, message: "最大长度不超过 32 个字符" }
        ],
        name: [
          { required: true, message: '请输入管理员名称', trigger: 'blur' },
          { max:32, message: "最大长度不超过 64 个字符" }
        ],
        groupName: [
          { required: true, message: '请输入机构名称', trigger: 'blur' },
          { max:32, message: "最大长度不超过 256 个字符" }
        ],
        belong: [
          { required: true, message: '请选择机构版本', trigger: 'blur' }
        ],
        address: [
          { max:500, message: "最大长度不超过 500 个字符" }
        ],
        telephone: [
          { max:16, message: "最大长度不超过 16 个字符" }
        ]
      },
      //系统
      belongList: [
          { name: "网络货运", code: "TMS" },
          { name: "同城", code: "CTMS" },
          { name: "仓储", code: "WMS" },
          { name: "园区", code: "PARK" }
      ],
      branchDetail:{
      },
      isSuperShow: false,
      isSuperNotShow:false,
      partyType: '', // 用户类型
    }
    },
  created() {
    this.demo();
  },
  methods: {
    // 提交
    funcSubmit() {
      this.$refs['form'].validate((valid) => {
        if (valid) {
          const data = this.form
          const rLoading = this.openLoading(15000);
          request({ url: '/ntocc-basic-api/partyGroup/addBranch', method: 'post', data: data }).then(response => {
            rLoading.close()
            this.$message({ message: response.msg, type: 'success' })
            this.$emit('fatherAddMethod')
          }).then(() => this.$refs['form'].resetFields())
        } else {
          return false
        }
      })
    },
    findRoleList() {
      request({
        url: '/ntocc-basic-api/role',
        method: 'get',
        params: {}
      }).then(response => {
        this.partyTypeOptions = response.data.records;
      })
    },
    demo() {
      request({url: '/ntocc-basic-api/party/one', method: 'get'}).then(response => {
        this.branchDetail = response.data.msg
        this.$emit('fatherAddMethod')
        this.partyType = response.data.partyType
        if (response.data.partyType == 'SUPER_ADMIN') {
          this.isSuperShow = true
          this.isSuperNotShow = false
        } else {
          this.isSuperShow = false;
          this.isSuperNotShow = true;
          this.findRoleList();
        }
      })
    },
    // 取消
    funcCancel() {
      this.$emit('fatherCancelMethod', 'add')
    }
  }
}
</script>
<style lang="scss" scoped>
  .dialog-footer {
    margin: 15px 0 15px 0;
    width: 175px;
    float: right;
  }
</style>
